module.exports = __webpack_public_path__ + "img/zone100200.744ae495.png";